webpackJsonp([111930841657428],{

/***/ 2737:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image1.e419087b.png";

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(257);
	
	var _image = __webpack_require__(2737);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _project = __webpack_require__(2738);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return (
	    // <Link to="/">Go back to the homepage</Link>
	    _react2.default.createElement(
	      'div',
	      { className: 'row project-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8 col-md-offset-2' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'project-title' },
	          'Il Progetto ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'DailyClouds'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'DailyClouds'
	          ),
	          ' pubblica ogni giorno un\'immagine che mostra le parole pi\xF9 usate nelle notizie pubblicate dalle maggiori testate giornalistiche italiane, utilizzando il testo contenuto nei feeds ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://it.wikipedia.org/wiki/RSS' },
	            'RSS'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Il progetto \xE8 basato su uno script Python, ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://github.com/inmagik/newsclouds-engine' },
	            'newsclouds-engine'
	          ),
	          ', che, dato un testo, lo analizza, estrae le parole con maggior ricorrenza e genera un\'immagine dove le parole pi\xF9 grandi sono quelle pi\xF9 ricorrenti.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Project-image-div' },
	          _react2.default.createElement('img', { src: _image2.default, className: 'Project-image' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Ogni giorno generiamo una cloud con un ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://it.wikipedia.org/wiki/Raspberry_Pi' },
	            'Raspberry pi'
	          ),
	          ', dalla nostra sede operativa a Bergamo, che salva le immagini sul repository github ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://github.com/inmagik/newsclouds-stock' },
	            'newsclouds-stock'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Questo sito, la web-app DailyClouds, realizzata con ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://facebook.github.io/react/' },
	            'React.js'
	          ),
	          ', visualizza le immagini salvate sul repository github newsclouds-stock.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Project-image-div' },
	          _react2.default.createElement('img', { src: _project2.default, className: 'Project-image' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          { className: 'project-title' },
	          'RSS Feeds - Giornali italiani'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Questi sono i link dei feeds RSS dei giornali italiani utilizzati nel progetto DailyClouds. Utilizziamo le testate gionalistiche di cui disponiamo di un feed RSS.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'Project-feeds-list' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.ansa.it/main/notizie/awnplus/topnews/synd/ansait_awnplus_topnews_medsynd_Today_Idx.xml' },
	              'ANSA'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.repubblica.it/rss/homepage/rss2.0.xml' },
	              'la Repubblica'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://xml.corriereobjects.it/rss/homepage.xml' },
	              'Corriere della Sera'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.ilfattoquotidiano.it/feed/' },
	              'il Fatto Quotidiano'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.lastampa.it/rss.xml' },
	              'La Stampa'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.ilmattino.it/rss/primopiano.xml' },
	              'Il Mattino'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.ilmessaggero.it/rss/primopiano.xml' },
	              'Il Messaggero'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.ilgiornale.it/feed.xml' },
	              'il Giornale'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.liberoquotidiano.it/rss.jsp?sezione=1' },
	              'Libero'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://ws3.class.it/rssfeed/rss.asmx/RssFeed?tipo=io_artpp' },
	              'Italia Oggi'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.ilgazzettino.it/rss/home.xml' },
	              'Il Gazzettino'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.ilsecoloxix.it/homepage/rss/homepage.xml' },
	              'Il Secolo XIX'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.ilsole24ore.com/rss/notizie/attualita.xml' },
	              'Il Sole 24 ORE'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'http://www.ilfoglio.it/rss.jsp?sezione=108' },
	              'IL FOGLIO'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Segnalaci altri feeds all\'indirizzo ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:info@inmagik.com' },
	            'info@inmagik.com'
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 2738:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/project.761e8aff.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-project-js-7760a4c12a6d1eadc298.js